import { render, staticRenderFns } from "./XReadingTable.vue?vue&type=template&id=1d3cca58"
import script from "./XReadingTable.vue?vue&type=script&lang=js"
export * from "./XReadingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports